import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useBuilding, useCompany, useLocation } from 'zens-store'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  locationId: number
  buildingId?: number
  title?: string
  breadcrumbItems?: BreadcrumbData[]
}

const BuildingHeader = (props: Props) => {
  const { companyId, locationId, buildingId = 0, title, breadcrumbItems, style, ...otherProps } = props
  const company = useCompany({ companyId })
  const location = useLocation({ companyId, locationId })
  const building = useBuilding({ companyId, buildingId })

  const breadcrumb = useBreadcrumb([
    {
      title: company.data?.name || '',
      href: `/companies/${companyId}`,
    },
    {
      title: location.data?.name || '',
      href: `/companies/${companyId}/locations/${locationId}`,
    },
    ...(buildingId
      ? [
          {
            title: building.data?.name || '',
            href: `/companies/${companyId}/locations/${locationId}/buildings/${buildingId}`,
          },
        ]
      : []),
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={title || building.data?.name || ' '}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default BuildingHeader
